import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import CardLayout from "../CardLayout";

export function HoveredCard({
  buttonText,
  onMouseLeave,
  disabled,
  onClick,
  loading,
  children,
}) {
  return (
    <CardLayout
      onMouseLeave={onMouseLeave}
      contentStyle={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      description={
        <span
          style={{
            fontSize: "13px",
            color: "black",
            cursor: "default",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "7",
            lineHeight: "1em",
            height: "7em",
          }}
        >
          {children}
        </span>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Button
          primary
          size="tiny"
          style={{
            marginBottom: "0.5em",
            backgroundColor: "#536DFE",
            width: "70%",
          }}
          loading={loading}
          disabled={disabled || loading}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </div>
    </CardLayout>
  );
}

HoveredCard.propTypes = {
  buttonText: PropTypes.string,
  onMouseLeave: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

HoveredCard.defaultProps = {
  buttonText: "Add to Hub",
  children: null,
  loading: false,
  disabled: false,
};

export default HoveredCard;
